var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 9L5 5L1 1","stroke":"#1B1B1B","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Arrow.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
